module.exports = __webpack_public_path__ + "img/bg-8.cd7de686.jpg";